var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 44,
    viewBox: "0 0 37 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.065 0c.973 0 1.905.387 2.592 1.074l7.936 7.935a3.668 3.668 0 011.074 2.593v28.731A3.667 3.667 0 0133 44H3.667A3.667 3.667 0 010 40.333V3.667A3.667 3.667 0 013.667 0h21.398zM8.25 32.083a1.834 1.834 0 000 3.667h8.25a1.833 1.833 0 000-3.667H8.25zm0-7.333a1.833 1.833 0 000 3.667h16.5a1.834 1.834 0 000-3.667H8.25zm0-7.333a1.833 1.833 0 100 3.666h16.5a1.833 1.833 0 100-3.666H8.25z",
    fill: "#2B8982"
  })));
}
export default SvgDocumentCard;